/**
 * Validação do formulário de registro/cadastro
 */
export function accountLogin() {
  const registerForm = document.querySelector('form.woocommerce-form-register, form.register');
  if (!registerForm) return;

  const passwordField = document.getElementById('reg_password');
  const passwordConfirmField = document.getElementById('reg_password_confirm');
  
  if (!passwordField || !passwordConfirmField) return;

  registerForm.addEventListener('submit', function(e) {
    if (passwordField.value !== passwordConfirmField.value) {
      e.preventDefault();
      alert('As senhas não coincidem. Por favor, verifique e tente novamente.');
      passwordConfirmField.focus();
      return false;
    }
  });

  passwordConfirmField.addEventListener('blur', function() {
    if (passwordField.value !== passwordConfirmField.value) {
      passwordConfirmField.setCustomValidity('As senhas não coincidem');
    } else {
      passwordConfirmField.setCustomValidity('');
    }
  });
}

/**
 * Funcionalidade para mostrar/esconder senha
 * Usar classe '.toggle-password-visibility'
 */
export function initPasswordVisibilityToggle() {
  const toggleButtons = document.querySelectorAll('.toggle-password-visibility');
  
  if (!toggleButtons.length) return;

  toggleButtons.forEach(function(button) {
    if (button.hasAttribute('data-password-toggle-initialized')) return;
    button.setAttribute('data-password-toggle-initialized', 'true');

    const container = button.closest('.relative, .password-wrapper, div');
    let passwordInput = null;
    
    if (container) {
      passwordInput = container.querySelector('input[type="password"], input[type="text"][id*="password"], input[name*="password"]');
    }
    
    if (!passwordInput) {
      const possibleIds = ['password', 'reg_password', 'reg_password_confirm', 'password_confirm'];
      for (let id of possibleIds) {
        const input = document.getElementById(id);
        if (input && (input.type === 'password' || input.name.includes('password'))) {
          // Verifica se o botão está próximo ao input (mesmo formulário ou container)
          const inputContainer = input.closest('form, .woocommerce-form, div');
          const buttonContainer = button.closest('form, .woocommerce-form, div');
          if (inputContainer === buttonContainer || container?.contains(input)) {
            passwordInput = input;
            break;
          }
        }
      }
    }

    if (!passwordInput) {
      console.warn('Campo de senha não encontrado para o botão de toggle');
      return;
    }

    button.addEventListener('click', function(e) {
      e.preventDefault();
      e.stopPropagation();
      if (passwordInput.type === 'password') {
        passwordInput.type = 'text';
        button.setAttribute('aria-label', 'Ocultar senha');
        button.setAttribute('aria-pressed', 'true');
        button.classList.add('password-visible');
      } else {
        passwordInput.type = 'password';
        button.setAttribute('aria-label', 'Mostrar senha');
        button.setAttribute('aria-pressed', 'false');
        button.classList.remove('password-visible');
      }
    });
    button.setAttribute('aria-label', 'Mostrar senha');
    button.setAttribute('aria-pressed', 'false');
    button.setAttribute('type', 'button');
  });
}
